import { useContext } from 'react';

import FavoritesContext from './favorites.context';

function useFavorites() {
  const context = useContext(FavoritesContext);

  if (!context) {
    throw new Error('useFavorites must be used within FavoritesContext');
  }

  return context;
}

export default useFavorites;
